// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__178ht","top":"styles_top__eh3C9"};